import { useOpenPopup } from "context/popup-context";
import React from "react";

export const useBrandVoice = () => {
  const openPopup = useOpenPopup();

  const openAddInfoBase = React.useCallback(() => {
    openPopup("infoBasePopup", {});
  }, [openPopup]);

  const openAddStyle = React.useCallback(() => {
    openPopup("stylePopup", {});
  }, []);

  return { openAddInfoBase, openAddStyle };
};
